import { createContext, useContext } from 'react';

import { TrackingContextProps } from './tagManager.types';

const TrackingContext = createContext<TrackingContextProps>({
  trackEvent: () => ({}),
  trackPageLoad: () => ({}),
  trackEventForm: () => ({}),
});

export const TrackingProvider = TrackingContext.Provider;

export const useTracking = (): TrackingContextProps =>
  useContext(TrackingContext);
